import React from 'react'
import { useUserImpersonation } from '@/utilities/Hooks/useUserImpersonation'
import { useUser } from '@/queries/hooks/use-user'
import Button from '@/components/Button'
import ReactTooltip from '@/components/Tooltip/ReactTooltip'

const ImpersonationBanner: React.FC = () => {
  const { isImpersonating, impersonatedUserId, clearImpersonation } =
    useUserImpersonation()
  const { data: user } = useUser()

  if (!isImpersonating) {
    return null
  }

  const displayName =
    user?.profile?.displayName ||
    `${user?.profile?.firstName || ''} ${user?.profile?.lastName || ''}`.trim() ||
    'Unknown User'

  return (
    <div className='fixed top-0 left-0 right-0 bg-yellow-500 text-black px-4 py-3 z-[9999] flex items-center justify-between shadow-lg border-b-2 border-yellow-600'>
      <div className='flex items-center space-x-3'>
        <div className='flex items-center'>
          <svg
            className='w-5 h-5 mr-2'
            fill='currentColor'
            viewBox='0 0 20 20'
            aria-hidden='true'
          >
            <path
              fillRule='evenodd'
              d='M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z'
              clipRule='evenodd'
            />
          </svg>
          <span className='font-semibold text-sm'>User Impersonation</span>
        </div>
        <div className='flex items-center space-x-2'>
          <span className='text-sm font-medium'>Viewing as:</span>
          <span
            className='text-sm bg-yellow-600 text-white px-2 py-1 rounded font-medium'
            data-tooltip-id='impersonation-id-tooltip'
            data-tooltip-content={`Impersonation ID: ${
              impersonatedUserId ?? 'Unknown'
            }`}
          >
            {displayName}
          </span>
        </div>
      </div>

      <Button
        onClick={clearImpersonation}
        variant='destructive'
        size='sm'
        label='Exit Impersonation'
        aria-label='Exit user impersonation'
      />

      {/* Tooltip for impersonation ID */}
      <ReactTooltip id='impersonation-id-tooltip' place='bottom' />
    </div>
  )
}

export default ImpersonationBanner
